<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-6">
          <label class="label-input">Section Background</label>
          <div class="group-item">
            <div>
              <label class="label-input mb-0">Padding </label>
              <v-row>
                <v-col md="6" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
                  </div>
                </v-col>
                <v-col md="6" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['text-color']" label="Text Color" />
                  <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-color']"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields['background-color']" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="d-flex align-center gap-2 mb-2">
          <label class="label-input mb-0 d-flex align-center" htmlFor="review-infinite-show-header">
            Header
            <input
              class="ml-2 cursor-pointer"
              type="checkbox"
              v-model="fields.showHeader"
              id="review-infinite-show-header"
          /></label>
        </div>
        <div class="group-item">
          <div class="d-flex align-center mb-4">
            <input type="checkbox" v-model="fields['containerStyle']" id="containerStyle" />
            <label class="ml-2" for="containerStyle">
              The slider will be inside the container width will not overflow 100%.
            </label>
          </div>
          <ckeditor :editor="editor" v-model="fields['review-title']" :config="editorConfig" />
          <div class="mt-6">
            <div class="d-flex align-center mb-2">
              <input type="checkbox" v-model="fields['enableRating']" id="enableRating" />
              <label class="ml-2" for="enableRating">Show Average Rating</label>
            </div>
            <v-text-field
              :disabled="!fields['enableRating']"
              v-model.number="fields['rating-value']"
              label="Average Rating ⭐"
              type="number"
              min="1"
              max="5"
              step="0.1"
              :rules="[v => (v >= 0.1 && v <= 5) || 'Average rating must be between 0.1 and 5.0']"
              required
            />
          </div>
          <v-textarea class="mt-2" v-model="fields['description']" outlined label="Description" />
        </div>

        <div class="mt-6">
          <div class="d-flex align-center gap-2 mb-2">
            <label class="label-input mb-0 d-flex align-center" htmlFor="review-infinite-show-tag">
              Tag
              <input class="ml-2 cursor-pointer" type="checkbox" v-model="fields.showTag" id="review-infinite-show-tag"
            /></label>
          </div>
          <div class="group-item">
            <v-text-field class="mt-2" v-model="fields['tagContent']" label="Content" hide-details dense />
          </div>
        </div>

        <div class="mt-6">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input">Review Images ({{ fields['review-images'].length }})</label>
            <v-btn small text color="primary" @click="handleAddReviewImage">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Image</span>
            </v-btn>
          </div>
          <div class="wrap-reviews-form group-item">
            <div class="mb-2">
              <v-select v-model="fields['imageSize']" :items="imageSizeOptions" label="Image Size" />
            </div>
            <div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields['review-images']" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <div class="reviewer-header">
                        <div class="reviewer-avatar">
                          <img :src="item.avatar" alt="" onerror="this.style.display='none'" />
                        </div>
                      </div>
                      <v-btn icon @click.stop="handleRemoveReviewImage(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="wrap-review-form">
                      <div class="mb-5">
                        <label>Review Image</label>
                        <UploadImage
                          :ref="`uploadComponent${i}`"
                          @callback="obj => handleUploadAvatar(obj, i)"
                          :image="{ imageSrc: item.avatar }"
                          :height="`150`"
                          :typeUpload="'image'"
                          @callbackDelete="handleRemoveAvatar(i)"
                        />
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </v-card-text>

      <!-- Upload Modal -->
      <v-dialog v-model="showUploadModal" :width="500" persistent>
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Upload New Image</span>
            <v-btn icon @click="showUploadModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <UploadImage
                ref="modalUploadComponent"
                @callback="handleModalUpload"
                :image="{ imageSrc: pendingImageUpload || '' }"
                :height="`300`"
                :typeUpload="'image'"
                @callbackDelete="handleModalUploadDelete"
              />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showUploadModal = false">Cancel</v-btn>
            <v-btn color="primary" @click="confirmUpload" :disabled="!pendingImageUpload"> Add Image </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeepObject } from '../common/utils';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'ReviewInfiniteMarqueeSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      showUploadModal: false,
      pendingImageUpload: null,
      fields: {
        title: 'Review Infinite Marquee Section',
        'review-title': 'Real Results from Real People',
        'rating-value': 5,
        enableRating: true,
        description: '4,700+ Happy Customers',
        'review-images': [],
        imageSize: 'large',
        'text-color': '',
        'background-color': '',
        topPadding: true,
        bottomPadding: true,
        containerStyle: true,
        showHeader: true,
        showTag: false,
        tagContent: '',
      },
      imageSizeOptions: [
        { text: 'Small', value: 'small' },
        { text: 'Large', value: 'large' },
      ],
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updatedSection = {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtmlFromData.sectionReviewInfiniteMarquee(this.sectionEditor.section.html, this.fields),
      };
      this.$emit('update:section', updatedSection);
      this.handleClosePopup();
    },
    handleAddReviewImage() {
      // Show upload modal instead of auto-adding
      this.showUploadModal = true;
      this.pendingImageUpload = null;
    },
    handleRemoveReviewImage(index) {
      this.fields['review-images'].splice(index, 1);
    },
    handleUploadAvatar(obj, index) {
      if (obj && obj.imageSrc) {
        this.fields['review-images'][index].avatar = obj.imageSrc;
      }
    },
    handleRemoveAvatar(index) {
      this.fields['review-images'][index].avatar = '';
    },
    handleModalUpload(obj) {
      this.pendingImageUpload = obj.imageSrc;
    },
    handleModalUploadDelete() {
      this.pendingImageUpload = null;
    },
    confirmUpload() {
      if (this.pendingImageUpload) {
        // Process the uploaded image URL
        let url = this.pendingImageUpload;

        // Add the new image to the list
        this.fields['review-images'].unshift({
          avatar: url,
        });

        // Auto-expand the first panel to show the uploaded image
        this.$nextTick(() => {
          const panels = this.$el.querySelectorAll('.v-expansion-panel');
          if (panels.length > 0) {
            const firstPanel = panels[0];
            const header = firstPanel.querySelector('.v-expansion-panel-header');
            if (header && !firstPanel.classList.contains('v-expansion-panel--active')) {
              header.click();
            }
          }
        });
      }

      // Close modal and reset
      this.showUploadModal = false;
      this.pendingImageUpload = null;
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
  },
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = cloneDeepObject(this.sectionEditor.sectionExtract);
    }
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal.sectionExtract) {
          this.fields = cloneDeepObject(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable {
  min-height: 150px !important;
}
::v-deep .ck-editor__editable_inline {
  min-height: 150px !important;
}

.label-input {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.wrap-review-form {
  padding: 16px 0;
}

.wrap-reviews-form {
  margin-top: 20px;
}

.header-modal,
.footer-modal {
  padding: 0 24px;
  border-bottom: 1px solid #e0e0e0;
}

.footer-modal {
  border-top: 1px solid #e0e0e0;
  border-bottom: none;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.gap-3 {
  gap: 12px;
}

.reviewer-header {
  display: flex;
  align-items: center;
  gap: 12px;

  .reviewer-avatar {
    width: 80px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e0e0e0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
      z-index: 2;
    }

    &::before {
      content: '';
      font-size: 20px;
      color: #999;
      position: absolute;
    }
  }

  .reviewer-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .reviewer-name {
    font-size: 16px;
    font-weight: 500;
  }
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
